<app-subsection-title key="provider.tender.project.conclusion.title" />

<div>
  @if (this.hrToolProviderDecisionResource.isLoading()) {
    <app-loading />
  } @else if (selectedProviderDetails()) {
    @let winner = selectedProviderDetails()!;
    @if (selectedProviderFees(); as fees) {
      <app-provider-selection-winner
        [offerProviderDetails]="winner"
        [projectId]="projectId()"
        [inputObject]="fees"
        [comment]="draftComment()"
        [isReadOnly]="true"
      ></app-provider-selection-winner>
    }

    @if (contractProjectDecision()) {
      @if (hasActivities() && !providerDeclined()) {
        <p-divider></p-divider>
        <div class="flex justify-end mt-6">
          <p-button
            label="{{ 'provider.tender.project.conclusion.declineButton' | transloco }}"
            class="mr-1"
            severity="secondary"
            (onClick)="declinePhase()"
          ></p-button>
          <p-button
            label="{{ 'provider.tender.project.conclusion.finishButton' | transloco }}"
            (onClick)="finishPhase()"
          ></p-button>
        </div>
      }
    }
  }
</div>
